import { useConsent } from '../lib/consent';
import { useI18n } from '../i18n';

// Shared legal content — rendered both inside the LegalModal (the
// landing-page surface) and on the standalone /privacy + /terms routes
// (the URLs we hand to the App Store + Play Store listings). Keeping
// the bodies in one place means the modal and the public URL can't
// drift out of sync, which is the whole point of having a single
// source of truth for legal text.

export function CompanyBlock() {
  const { t } = useI18n();
  return (
    <div class="legal-company">
      <h4>{t('legal.company')}</h4>
      <p style={{ fontWeight: 600, color: 'var(--text-dark)' }}>Insert Coin SAGL</p>
      <p>Via Salici 7</p>
      <p>6987 Caslano, Ticino — Switzerland</p>
      <p style={{ marginTop: '0.3rem' }}>
        UID: CHE-187.955.806 (
        <a
          href="https://www.uid.admin.ch/Detail.aspx?uid_id=CHE187955806&lang=en"
          target="_blank"
          rel="noopener"
        >
          {t('legal.registry')}
        </a>
        )
      </p>
      <a
        href="mailto:info@insert-coin.io"
        style={{ marginTop: '0.3rem', display: 'inline-block' }}
      >
        info@insert-coin.io
      </a>
    </div>
  );
}

function PrefsBlock() {
  const { consent, reset } = useConsent();
  const { t } = useI18n();
  const isSet = consent !== null;
  const statusClass = !isSet ? 'unset' : consent.accepted ? 'accepted' : 'declined';
  const statusText = !isSet
    ? t('legal.prefs_not_set')
    : consent.accepted
    ? t('legal.prefs_accepted')
    : t('legal.prefs_declined');

  return (
    <div class="legal-prefs">
      <div class="legal-prefs-top">
        <h4>{t('legal.prefs_title')}</h4>
        <span class={`legal-status ${statusClass}`}>{statusText}</span>
      </div>
      {isSet && (
        <>
          <p>{t('legal.prefs_text')}</p>
          <button class="legal-reset-btn" onClick={reset}>
            {t('legal.prefs_reset')}
          </button>
        </>
      )}
    </div>
  );
}

export function PrivacyBody() {
  const { t } = useI18n();
  return (
    <>
      <CompanyBlock />
      <PrefsBlock />
      <div class="legal-content">
        <p>{t('legal.privacy_intro')}</p>
        <h3>{t('legal.privacy_h1')}</h3>
        <p>{t('legal.privacy_p1')}</p>
        <ul>
          <li>{t('legal.privacy_li1')}</li>
          <li>{t('legal.privacy_li2')}</li>
          <li>{t('legal.privacy_li3')}</li>
          <li>{t('legal.privacy_li4')}</li>
        </ul>
        <h3>{t('legal.privacy_h2')}</h3>
        <p>{t('legal.privacy_p2')}</p>
        <h3>{t('legal.privacy_h3')}</h3>
        <p>{t('legal.privacy_p3')}</p>
        <h3>{t('legal.privacy_h4')}</h3>
        <p>{t('legal.privacy_p4')}</p>
        <h3>{t('legal.privacy_h5')}</h3>
        <p>{t('legal.privacy_p5')}</p>
        <h3>{t('legal.privacy_h6')}</h3>
        <p>{t('legal.privacy_p6')}</p>
      </div>
    </>
  );
}

export function TermsBody() {
  const { t } = useI18n();
  return (
    <>
      <CompanyBlock />
      <div class="legal-content">
        <h3>{t('legal.terms_h1')}</h3>
        <p>{t('legal.terms_p1')}</p>
        <h3>{t('legal.terms_h2')}</h3>
        <p>{t('legal.terms_p2')}</p>
        <h3>{t('legal.terms_h3')}</h3>
        <p>{t('legal.terms_p3')}</p>
        <h3>{t('legal.terms_h4')}</h3>
        <p>{t('legal.terms_p4')}</p>
        <h3>{t('legal.terms_h5')}</h3>
        <p>{t('legal.terms_p5')}</p>
        <h3>{t('legal.terms_h6')}</h3>
        <p>{t('legal.terms_p6')}</p>
        <h3>{t('legal.terms_h7')}</h3>
        <p>{t('legal.terms_p7')}</p>
      </div>
    </>
  );
}
